import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';

class RelatedFMISRecord extends Component {

  //TODO: Duplicated with WFMI
  getDateString = (value) =>
  {
  return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
  return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  render()
  {
    return (
      <Paper elevation={3}>
      <Table size="small">
      <TableBody>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Record Number:</TableCell>
        <TableCell>{this.props.record.RecordNumber}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Unit Identifier:</TableCell>
        <TableCell>{this.props.record.UnitIdentifier}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Org Code:</TableCell>
        <TableCell>{this.props.record.OrgCode}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Org Name:</TableCell>
        <TableCell>{this.props.record.OrgName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Unique Fire ID:</TableCell>
        <TableCell>{this.props.record.UniqueFireId}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Incident Name:</TableCell>
        <TableCell>{this.props.record.IncidentName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Code:</TableCell>
        <TableCell>{this.props.record.FireCode}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Report Status:</TableCell>
        <TableCell>{this.props.record.ReportStatus}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fiscal Year:</TableCell>
        <TableCell>{this.props.record.FiscalYear}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Calendar Year:</TableCell>
        <TableCell>{this.props.record.CalendarYear}</TableCell>
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>Region:</TableCell>
        <TableCell>{this.props.record.Region}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Incident Kind:</TableCell>
        <TableCell>{this.props.record.IncidentKind}</TableCell>
      </TableRow>
      <TableRow>
       <TableCell style={{fontWeight:"bold"}}>Incident Category:</TableCell>
        <TableCell>{this.props.record.IncidentCategory}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Sub Category:</TableCell>
        <TableCell>{this.props.record.SubCategory}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Cause:</TableCell>
        <TableCell>{this.props.record.FireCause}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Discovery Date:</TableCell>
        <TableCell>{this.props.record.DiscoveryDateTime}</TableCell>
      </TableRow>
      <TableRow>
      <TableCell style={{fontWeight:"bold"}}>Latitude:</TableCell>
        <TableCell>{this.props.record.Latitude}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude:</TableCell>
        <TableCell>{this.props.record.Longitude}</TableCell>
      </TableRow>
      <TableRow>
       <TableCell style={{fontWeight:"bold"}}>Landowner Kind:</TableCell>
        <TableCell>{this.props.record.LandownerKind}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Landowner Category:</TableCell>
        <TableCell>{this.props.record.LandownerCategory}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Init Attack Date:</TableCell>
        <TableCell>{this.props.record.InitAttackDateTime}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Containment Date:</TableCell>
        <TableCell>{this.props.record.FireContainDateTime}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Control Date:</TableCell>
        <TableCell>{this.props.record.ControlDateTime}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Out Date:</TableCell>
        <TableCell>{this.props.record.OutDate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>FWS Acres:</TableCell>
        <TableCell>{this.props.record.FWSAcres}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Total Acres:</TableCell>
        <TableCell>{this.props.record.TotalAcres}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Multiple Objective Acres:</TableCell>
        <TableCell>{this.props.record.MultipleObjectiveAcres}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Narrative:</TableCell>
        <TableCell>{this.props.record.Narrative}</TableCell>
      </TableRow>
      </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedFMISRecord;
